module.exports = __webpack_public_path__ + "static/img/IMG_0411.1513e07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/IMG_0411.jpg
// module id = iBY8
// module chunks = 4